"use strict";

function _typeof(obj) {"@babel/helpers - typeof";return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof(obj);}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separation = exports.PageButton = exports.NavigationButton = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _IconButton = _interopRequireWildcard(require("../../../IconButton"));
var _Icon = require("../../../Icon");
var _Button = _interopRequireWildcard(require("../../../Button"));
var _types = require("../../types");
function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}
function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {return { default: obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj.default = obj;if (cache) {cache.set(obj, newObj);}return newObj;}
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var NavigationButton = (0, _styledComponents.default)(_IconButton.default).attrs(function (_a) {
  var $type = _a.$type;
  return {
    icon: $type === _types.PaginationElementTypes.PreviousPageButton ? _Icon.Icons.ChevronLeft : _Icon.Icons.ChevronRight,
    shape: _IconButton.IconButtonShapes.Circle
  };
}).withConfig({
  displayName: "fluffy--NavigationButton",
  componentId: "fluffy--1e11otq"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: auto 0;\n"], ["\n    margin: auto 0;\n"])));
exports.NavigationButton = NavigationButton;
var PageButton = (0, _styledComponents.default)(_Button.default).attrs(function (_a) {
  var $active = _a.$active,
    variant = _a.variant;
  return {
    variant: $active ? variant : _Button.ButtonVariants.Text
  };
}).withConfig({
  displayName: "fluffy--PageButton",
  componentId: "fluffy--p2o5z3"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var $active = _a.$active;
  return !$active && (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        color: #2E2A25\n    "], ["\n        color: #2E2A25\n    "])));
});
exports.PageButton = PageButton;
var Separation = _styledComponents.default.p.withConfig({
  displayName: "fluffy--Separation",
  componentId: "fluffy--dqfl2y"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    min-width: 40px;\n    display: flex;\n    justify-content: center;\n    margin: auto 0;\n"], ["\n    min-width: 40px;\n    display: flex;\n    justify-content: center;\n    margin: auto 0;\n"])));
exports.Separation = Separation;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;